import React from "react";

export default function HideNav({ onClick }) {
  const size = 32;

  return (
    <button
      onClick={onClick}
      style={{
        width: `${size}px`,
        height: `${size}px`,
        border: "none",
        background: "transparent",
        cursor: "pointer",
        fontSize: `${size * 0.75}px`,
        lineHeight: 1,
        padding: 0,
      }}
      aria-label="Hide navigation"
    >
      ×
    </button>
  );
}
